import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartStateService {

  private cartCountSubject = new BehaviorSubject<number>(0);
  cartCount$ = this.cartCountSubject.asObservable();

  private cartItemsSubject = new BehaviorSubject<any[]>([]);
  cartItems$ = this.cartItemsSubject.asObservable();

  constructor() {}

  // Set full cart from API
  setItems(items: any[]) {
    this.cartItemsSubject.next(items);

    const totalQty = items.reduce((sum, i) => sum + (i.qty || 0), 0);
    this.cartCountSubject.next(totalQty);
  }

  // Only update count
  setCount(count: number) {
    this.cartCountSubject.next(count);
  }

  updateItemQuantity(productVariantId: number, quantity: number) {
    const currentCount = this.cartCountSubject.value;

    // Increase badge count immediately
    this.cartCountSubject.next(currentCount + quantity);
  }

  // Clear cart (logout / empty)
  clearCart() {
    this.cartItemsSubject.next([]);
    this.cartCountSubject.next(0);
  }
}
